export const OPEN_MODAL = "open_modal"
export const RESET_PASSWORD_CODE = "code"
